module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.library.js
 ** module id = 79
 ** module chunks = 0
 **/